export function openAccordion(name, index, config = {}) {
  return {
    type: 'OPEN_ACCORDION',
    name,
    index,
    config
  };
}

export function closeAccordion(name, index) {
  return {
    type: 'CLOSE_ACCORDION',
    name,
    index
  };
}

export function toggleAccordion(name, index, item) {
  return {
    type: 'TOGGLE_ACCORDION',
    name,
    index,
    item
  };
}
